import { render, staticRenderFns } from "./departure-ranking.vue?vue&type=template&id=e0ebc5c0&"
import script from "./departure-ranking.vue?vue&type=script&lang=js&"
export * from "./departure-ranking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports